import Layout, { Container } from "../components/layout";
import React, { useState } from "react";
import axios from "axios";
import { UploadCloud, CheckCircle2 } from "lucide-react";
// import WeekOffUploadModal from "./WeekOffUploadModal";
import { apiurl } from "../config/config";

import { Upload, X, CheckCircle } from "lucide-react";
import * as XLSX from "xlsx";

// const WeekoffRoster = () => {
//   const today = new Date();

//   const [open, setOpen] = useState(false);
//   const [month, setMonth] = useState(today.getMonth() + 1);
//   const [year, setYear] = useState(today.getFullYear());
//   const [result, setResult] = useState(null);

//   const handleUpload = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("month", month);
//     formData.append("year", year);

//     const res = await axios.post(
//       `${apiurl}/api/attendance/upload-weekoff`,
//       formData
//     );

//     setResult(res.data);
//     setOpen(false);
//   };

//   return (
//     <Layout>
//       <Container>
//         <div className="flex items-center justify-between mb-6">
//           <h1 className="text-2xl font-bold">Week-Off Roster</h1>
//           <button
//             onClick={() => setOpen(true)}
//             className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2 rounded-xl shadow hover:bg-blue-700"
//           >
//             <UploadCloud size={18} /> Upload Roster
//           </button>
//         </div>

//         {/* Result Summary */}
//         {result && (
//           <div className="bg-green-50 border border-green-200 rounded-xl p-5 flex gap-4 items-start">
//             <CheckCircle2 className="text-green-600 mt-1" />
//             <div>
//               <p className="font-semibold text-green-700">Upload Successful</p>
//               <p className="text-sm">Created: {result.created}</p>
//               <p className="text-sm">Updated: {result.updated}</p>
//               {result.skipped?.length > 0 && (
//                 <p className="text-sm text-red-600">
//                   Skipped Employees: {result.skipped.join(", ")}
//                 </p>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Upload Modal */}
//         {open && (
//           <WeekOffUploadModal
//             month={month}
//             year={year}
//             setMonth={setMonth}
//             setYear={setYear}
//             onClose={() => setOpen(false)}
//             onConfirm={handleUpload}
//           />
//         )}
//       </Container>
//     </Layout>
//   );
// };


import { ChevronDown } from "lucide-react";
import {  XCircle } from "lucide-react";

const WeekoffRoster = () => {
  const [showModal, setShowModal] = useState(false);
  const [uploadedData, setUploadedData] = useState([]);

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Week-Off Roster</h1>
          <button
            onClick={() => setShowModal(true)}
            className="bg-blue-600 text-white px-5 py-2 rounded-lg"
          >
            Upload Week-Off Roster
          </button>
        </div>

        {/* Uploaded Result */}
        {uploadedData.length > 0 && (
          <div className="space-y-4">
            {uploadedData.map((emp, i) => (
              <details
                key={i}
                className="border rounded-lg p-4 cursor-pointer"
              >
                <summary className="flex justify-between items-center font-medium">
                  Employee ID: {emp.employeeId}
                  <ChevronDown size={18} />
                </summary>
                <div className="mt-3 flex flex-wrap gap-2">
                  {emp.days.map((d) => (
                    <span
                      key={d}
                      className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm"
                    >
                      Day {d} – WO
                    </span>
                  ))}
                </div>
              </details>
            ))}
          </div>
        )}

        {showModal && (
          <WeekOffUploadModal
            onClose={() => setShowModal(false)}
            onSuccess={(data) => {
              setUploadedData(data);
              setShowModal(false);
            }}
          />
        )}
      </Container>
    </Layout>
  );
};

export default WeekoffRoster;


const WeekOffUploadModal = ({ onClose, onSuccess }) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);

  const handleFile = (f) => {
    setFile(f);
    const reader = new FileReader();
    reader.onload = (e) => {
      const wb = XLSX.read(e.target.result, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });

      const headers = rows[0];
      const data = {};

      rows.slice(1).forEach((r) => {
        const empId = r[0];
        if (!empId) return;

        headers.forEach((h, i) => {
          if (!isNaN(h) && String(r[i]).toUpperCase() === "WO") {
            if (!data[empId]) data[empId] = [];
            data[empId].push(h);
          }
        });
      });

      setPreview(
        Object.keys(data).map((k) => ({
          employeeId: k,
          days: data[k],
        }))
      );
    };
    reader.readAsBinaryString(f);
  };

  const upload = async () => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("year", year);
    fd.append("month", month);

    await axios.post(`${apiurl}/api/attendance/upload-weekoff`, fd);
    onSuccess(preview);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-xl p-6">
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-semibold">Upload Week-Off Roster</h2>
          <XCircle onClick={onClose} className="cursor-pointer" />
        </div>

        {/* Year & Month */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="border p-2 rounded-lg"
          >
            {[currentYear - 1, currentYear, currentYear + 1].map((y) => (
              <option key={y}>{y}</option>
            ))}
          </select>

          <select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="border p-2 rounded-lg"
          >
            {Array.from({ length: 12 }).map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </select>
        </div>

        {/* Upload */}
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            handleFile(e.dataTransfer.files[0]);
          }}
          className="border-2 border-dashed rounded-xl p-6 text-center"
        >
          <Upload className="mx-auto mb-2" />
          <p>Drag & drop Excel file</p>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => handleFile(e.target.files[0])}
            className="hidden"
            id="file"
          />
          <label htmlFor="file" className="text-blue-600 cursor-pointer">
            Browse File
          </label>
        </div>

        {/* Preview */}
        {preview.length > 0 && (
          <div className="mt-4 max-h-48 overflow-auto border rounded-lg">
            <table className="w-full text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2 text-left">Employee</th>
                  <th className="p-2">Week-Off Days</th>
                </tr>
              </thead>
              <tbody>
                {preview.map((p) => (
                  <tr key={p.employeeId} className="border-t">
                    <td className="p-2">{p.employeeId}</td>
                    <td className="p-2">{p.days.join(", ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="flex justify-end gap-3 mt-5">
          <button onClick={onClose} className="border px-4 py-2 rounded-lg">
            Cancel
          </button>
          <button
            disabled={!file}
            onClick={upload}
            className="bg-blue-600 text-white px-5 py-2 rounded-lg disabled:opacity-50"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

